import * as Toastr from 'toastr';
import 'toastr/build/toastr.min.css'

Toastr.options.closeButton = true;
Toastr.options.closeButton = true;
Toastr.options.debug = false;
Toastr.options.newestOnTop = false;
Toastr.options.progressBar = true;
Toastr.options.positionClass = "toast-bottom-right";
Toastr.options.preventDuplicates = false;
Toastr.options.showDuration = 300;
Toastr.options.hideDuration = 1000;
Toastr.options.timeOut = 5000;
Toastr.options.extendedTimeOut = 1000;


export default class Toaster{

    public static Success(title: string, message: string) {
        Toastr["success"](message, title)
    }

    public static Info(title: string, message: string, params: any) {
        Toastr["info"](message, title,params)
    }

    public static Error(title: string, message: string, params : any) {
        Toastr["wrror"](message, title, params)
    }

    public static Warning(title: string, message: string) {
        Toastr["warning"](message, title)
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/helpers/Toaster.ts